import { render, staticRenderFns } from "./tooling-settings-list.component.vue?vue&type=template&id=32931996"
import script from "./tooling-settings-list.component.vue?vue&type=script&lang=ts"
export * from "./tooling-settings-list.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports